import { withStyles } from "@material-ui/core";
import React from "react";
import DueBill from "./DueBills";
import IBBill from "./IBBill";
import { getDataWithQueryString } from "./../../../../api/componentAPIs";
import { compose } from "recompose";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { withSnackbar } from "notistack";
import {
  checkAllBillsSelectedInBatch,
  checkPartialBillsSelectedInBatch,
  getExistingShipmentsInPlan,
  getInitialIBData,
} from "./utils";
import { withPlanDate } from "../PlanDateContext";
const styles = (theme) => ({
  button: {
    marginLeft: 16,
  },
  paperAnchor: {
    position: "absolute",
    padding: 0,
    borderLeft: `1px solid ${theme.AppBGColor}`,
    boxShadow: "none",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    backgroundColor: theme.gridBGColor,
    transform: "translate(0px, 0px)",
    transition: theme.transitions.create(["width"], {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  paperHidden: {
    height: 0,
    width: 0,
  },
  backdrop: {
    position: "absolute",
    backgroundColor: "transparent",
  },
  modal: {
    position: "absolute",
  },
});

class IBBills extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      IBData: null,
      openLayover: false,
      selectedBatch: null,
      selectedBatches: [],
    };
  }

  componentDidMount() {
    const {
      userData: { userProfile },
      planDate,
    } = this.props;
    getDataWithQueryString(
      "GetInboundBills",
      `terminalId=${userProfile.terminal.id}&terminalCode=${userProfile.terminal.code}&planDate=${planDate}`
    ).then(
      (IBData) => {
        if (IBData && IBData.status === 200) {
          this.setState({
            IBData: getInitialIBData(IBData, this.props.selectedShipmentIds),
          });
        } else {
          this.handleError();
        }
      },
      (_error) => {
        this.handleError();
      }
    );
  }

  handleError = () => {
    this.props.enqueueSnackbar("Unable to fetch inbound bills", {
      variant: "error",
    });
    this.setState({
      IBData: [],
    });
  };

  showDueBills = (selectedBatch) => {
    this.setState({
      openLayover: true,
      selectedBatch,
    });
  };

  closeOverlay = () => {
    this.setState({
      openLayover: false,
    });
  };

  updateSelectedBatches = (selectedBatch) => {
    const updatedData = this.state.IBData.map((batch) => {
      if (batch.id === selectedBatch.id) {
        const isSelectedAlready = batch.isSelected;
        const selectedBills = isSelectedAlready
          ? []
          : batch.shipmentsForDestTerminal.map((bill) => bill.proId);
        return {
          ...batch,
          isSelected: !isSelectedAlready,
          selectedPros: selectedBills,
          isIntermediate: false,
        };
      }
      return batch;
    });
    this.setState({
      IBData: updatedData,
    });
  };

  updateSelectedBills = (selectedPros) => {
    const updatedData = this.state.IBData.map((batch) => {
      if (batch.id === this.state.selectedBatch.id) {
        const inPlanBills = getExistingShipmentsInPlan(
          batch.shipmentsForDestTerminal
        );
        const totalSelectedBills = [...inPlanBills, ...selectedPros];
        return {
          ...batch,
          selectedPros,
          isSelected: checkAllBillsSelectedInBatch(
            totalSelectedBills.length,
            batch.shipmentsForDestTerminal.length
          ),
          isIntermediate: checkPartialBillsSelectedInBatch(
            totalSelectedBills.length,
            batch.shipmentsForDestTerminal.length
          ),
        };
      }
      return batch;
    });
    this.setState({
      IBData: updatedData,
      openLayover: false,
    });
  };

  getAllSelectedShipments = () => {
    const selectedShipments = this.state.IBData.reduce((acc, data) => {
      return [...acc, ...data.selectedPros];
    }, []);
    return selectedShipments;
  };

  handleNext = () => {
    const allSelectedShipments = this.getAllSelectedShipments();
    this.props.isLastStep
      ? this.props.handleSubmit(allSelectedShipments)
      : this.props.goToNextStep(allSelectedShipments);
  };

  render() {
    const {
      classes,
      userData: { userProfile },
      isLastStep,
    } = this.props;
    return (
      <>
        <IBBill
          data={this.state.IBData}
          glEventHub={this.props.glEventHub}
          showDueBills={this.showDueBills}
          handleNext={this.handleNext}
          goBack={this.props.goBack}
          updateSelectedBatches={this.updateSelectedBatches}
          userProfile={userProfile}
          isLastStep={isLastStep}
        />
        {this.state.openLayover && (
          <DueBill
            data={this.state.selectedBatch.shipmentsForDestTerminal}
            selectedPros={this.state.selectedBatch.selectedPros}
            glEventHub={this.props.glEventHub}
            onSubmit={this.updateSelectedBills}
            onCancel={this.closeOverlay}
            serviceLevelList={this.props.serviceLevelList}
            open
            anchor="bottom"
            variant="persistent"
            drawerClasses={{
              paper: `${classes.paperAnchor} customScroll ${
                !this.state.openLayover ? classes.paperHidden : ""
              }`,
              modal: classes.modal,
            }}
            BackdropProps={{
              className: classes.backdrop,
            }}
          />
        )}
      </>
    );
  }
}

export default compose(
  withPlanDate,
  withUserProfile,
  withSnackbar,
  withStyles(styles)
)(IBBills);
